import { MutationHookOptions, useMutation } from '@apollo/client'
import { CreateCodes, CreateCodesVariables } from '__generatedTypes__/CreateCodes'
import { CREATE_CODES } from 'queries/institutionalCodes'

export function useCreateCodesMutation(options?: MutationHookOptions<CreateCodes, CreateCodesVariables>) {
  return useMutation<CreateCodes, CreateCodesVariables>(CREATE_CODES, options)
}
